/* eslint-disable */

/* tslint:disable */

/* auto-generated react proxies */
import { createReactComponent } from './react-component-lib';
import { defineCustomElements } from 'img-comparison-slider/loader';
defineCustomElements();
export var ImgComparisonSlider = /*@__PURE__*/createReactComponent('img-comparison-slider');